var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.3828,
    height: 37.3828,
    rx: 18.6914,
    fill: "#323A4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6055 23.4571L18.6238 31.4853L29.1438 24.022V16L18.6055 23.4571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6477 23.4571L18.6293 31.4853L8.10938 24.022V16L18.6477 23.4571Z",
    fill: "#C1C8C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6055 14.8602L18.6238 6.83203L29.1438 14.2953V22.3173L18.6055 14.8602Z",
    fill: "#C1C8C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6477 14.8602L18.6293 6.83203L8.10938 14.2953V22.3173L18.6477 14.8602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFooter);
export default __webpack_public_path__ + "static/media/icon-footer.988e92e16716e33cd2edbad61781dfed.svg";
export { ForwardRef as ReactComponent };